import React from 'react';
import VoiceToTextTextarea from '@components/VoiceToTextTextarea';
import getVoiceToTextBlockedMessages from './VoiceTranscribing/utils';
import { AboutMeTypes } from '../StepThreeTypes';

interface SupportMeProps {
  aboutMe: AboutMeTypes;
  setAboutMe: (aboutMe: AboutMeTypes) => void;
}

const SupportMe: React.FC<SupportMeProps> = ({ aboutMe, setAboutMe }) => {
  return (
    <div className="govuk-form-group mt-10 govuk-bp:mt-14">
      <h1 className="govuk-label-wrapper">
        <label
          className="govuk-label govuk-label--l"
          htmlFor="how-when-support-me"
        >
          How and when to support me
        </label>
      </h1>
      <div className="govuk-body">
        A description of how and when you want someone caring for you to support
        you.
      </div>

      <div className="govuk-body">
        <ul className="govuk-list govuk-list--bullet">
          <li>
            This could include support needs in an emergency situation (for
            example taking blood)
          </li>
          <li>
            This could include support you need to maintain important routines
            or to carry out particular activities, for example: - Personal care
            routines, Eating and drinking, Bedtime routines, Taking medications,
            Moving and transitioning
          </li>
          <li>
            This could also include support needed with:- wearing
            glasses/hearing aids/false teeth etc, making informed choices or
            understanding dangers and risks, managing your emotions, moods and
            behaviours, memory or confusion.
          </li>
          <li>
            Include how your support needs change in different environments.
          </li>
          <li>
            Include any triggers that might result in you needing further
            support and strategies for avoiding or addressing the triggers.
          </li>
          <li>Include how you want the support to be provided.</li>
        </ul>
      </div>
      <details className="govuk-details">
        <summary className="govuk-details__summary">
          <span className="govuk-details__summary-text">Prompt questions</span>
        </summary>
        <div className="govuk-details__text">
          <ol className="govuk-list govuk-list--number">
            <li>
              <div className="govuk-body">
                What do people caring for and supporting you in an emergency
                need to know about how and when to support you?{' '}
              </div>
            </li>
            <li>
              <div className="govuk-body">
                What are your important routines? What are you able to do for
                yourself, what do you need support with and how do you want to
                be supported? Think about: your morning, bedtime and personal
                care routines. dressing and undressing. using the toilet. having
                a shower or bath. brushing your teeth.{' '}
              </div>
              <div className="govuk-body">
                Think about eating and drinking: Do you use any special bowls
                (e.g. lipped plate), cutlery (e.g. weighted spoon) or cups? How
                do you like your food presented (e.g. chopped up or liquified
                etc.)?{' '}
              </div>
              <div className="govuk-body">
                How do you like to be supported to eat (e.g. verbal prompts or
                physical help)? What do you like to drink and eat? How do you
                like to be supported in making food and drink choices? How do
                you like to be supported in preparing food?
              </div>
              <div className="govuk-body">
                Think about sleeping: Do you sleep well at night? What helps you
                to have a good night’s sleep (e.g. warm milk before bed, leaving
                lights on, music)? If you have disturbed sleep, how do you like
                to be supported?
              </div>
              <div className="govuk-body">
                Think about taking medication: How do you like to take your
                medication (e.g. liquid or tablet form, mixed up with a drink or
                food etc.) What helps you take your medication (e.g. verbal
                encouragement)? Think about your mobility: Do you use any
                walking aids (e.g. splints, frames, wheelchair)?
              </div>
              <div className="govuk-body">
                How do you like to be supported to move around? Think about what
                you can do for yourself and how you like to be supported when
                transferring? e.g. from a wheelchair to bed. Can you use public
                transport independently? If not, how do you like to be
                supported?
              </div>
              <div className="govuk-body">
                Think about memory and thoughts: What helps you remember things
                (e.g. use of diaries, apps or photographs etc.)? If you are
                confused what helps you and how do you like to be supported?
              </div>
              <div className="govuk-body">
                Think about your emotions, moods and behaviours: What do you
                find difficult or upsetting, how do you behave? How do you like
                to be supported to manage your emotions, moods and behaviours?
              </div>
              <div className="govuk-body">
                Think about work, college and/or leisure activities: How do you
                like to be supported in these activities?
              </div>
            </li>
            <li>
              <div className="govuk-body">
                What works well and what doesn’t work for you when someone is
                supporting you?
              </div>
            </li>
            <li>
              <div className="govuk-body">
                What triggers could result in you needing further support and
                strategies for avoiding or addressing the triggers?
              </div>
            </li>
            <li>
              <div className="govuk-body">
                How do your support needs change in different environments?
              </div>
            </li>
          </ol>
        </div>
      </details>
      <VoiceToTextTextarea
        id="how-when-support-me"
        name="howWhenSupportMe"
        value={aboutMe.supportMe || ''}
        rows={5}
        autoComplete="supportMe"
        placeholder="Type here or use voice to text..."
        recordBlockedErrors={getVoiceToTextBlockedMessages(aboutMe)}
        onChange={value => setAboutMe({ ...aboutMe, supportMe: value })}
      />
    </div>
  );
};

export default SupportMe;
